<script setup>
import {onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import ClientBondService from '@/services/ClientBondService';
import DashboardClientBonds from '@/components/dashboard/DashboardClientBonds.vue';

/**
 * IMA-517 fáze 7: karta Dluhopisy na detailu klienta (poradce, administrace).
 * Obsah je přehled dluhopisů klienta (DashboardClientBonds v pohledu poradce: rámcová smlouva, souhrn, záložky).
 * „Nakoupit dluhopisy“ spustí asistovaný onboarding s kalkulačkou (stejně jako vytvoření ASO na detailu klienta),
 * proto tlačítko jen ohlásí rodiči událost buy.
 */
const props = defineProps({
  entityId: {type: [Number, String], required: true},
  // lze založit ASO (stejná podmínka jako u tlačítka pro vytvoření onboardingu na detailu klienta)
  canBuy: {type: Boolean, default: false},
});
const emit = defineEmits(['buy']);

const {t} = useI18n();
const stats = ref(null);
const failed = ref(false);

onMounted(() => {
  ClientBondService.getStats(props.entityId).then(response => {
    stats.value = response;
  }).catch(() => {
    // 403/404 (role nebo klient mimo strukturu) – karta zobrazí jen informaci, detail klienta funguje dál
    failed.value = true;
  });
});
</script>

<template>
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center gap-2">
      <div class="card-header__title">{{ t('clientBonds.card_title') }}</div>
      <button type="button" class="btn btn-primary" :disabled="!canBuy" @click="emit('buy')">{{ t('clientBonds.buy_bonds') }}</button>
    </div>
    <div class="card-body">
      <div v-if="failed" class="text-muted">{{ t('clientBonds.card_unavailable') }}</div>
      <div v-else-if="!stats" class="text-center">
        <div class="spinner-border text-primary" role="status"><span class="visually-hidden">{{ t('clientBonds.loading') }}</span></div>
      </div>
      <DashboardClientBonds v-else :stats="stats" :client-id="entityId"/>
    </div>
  </div>
</template>
